export default "__VITE_ASSET__Bqpv631p__"